{
  "professionOptions": {
    "accountingBankingInsuranceFinance": {
      "title": "Comptabilité, banque, assurance et finances",
      "titles": {
        "accountant": "Comptable",
        "actuary": "Actuaire",
        "auditor": "Auditeur(trice)",
        "bankAdministrator": "Administrateur(trice) bancaire",
        "bookkeeper": "Bibliothécaire",
        "branchManager": "Directeur(trice) de succursale",
        "chiefFinancialOfficer": "Dirigeant(e) principal(e) des finances",
        "claimsAdjuster": "Ajusteur(euse) des réclamations",
        "clericalWorker": "Employé(e) de bureau",
        "commoditiesTrader": "Négociant(trice) de marchandises",
        "complianceRiskAnalyst": "Analyste de la conformité/risque",
        "consultant": "Conseiller(ère)",
        "controller": "Contrôleur(euse)",
        "creditAnalyst": "Analyste de crédit",
        "creditManager": "Gestionnaire de crédit",
        "customerServiceRepresentative": "Représentant(e) du service à la clientèle",
        "economist": "Économiste",
        "executiveSeniorManagementAccountingBankingInsuranceAndFinance": "Gestionnaire exécutif(ve)/principal(e), comptabilité, banque, assurance et finances",
        "financialAnalyst": "Analyste financier",
        "financialAdvisor": "Conseiller(ère) financier",
        "financialPlanner": "Planificateur(trice) financier",
        "insuranceAgent": "Agent(e) d’assurance",
        "insuranceBroker": "Courtier d’assurance",
        "internalAuditor": "Auditeur(trice) interne",
        "investmentAnalyst": "Analyste d'investissement",
        "investmentBanker": "Banquier d’investissement",
        "investmentConsultant": "Conseiller en investissement",
        "investmentFundManager": "Gestionnaire de fonds d'investissement",
        "investmentRepresentative": "Représentant en investissement",
        "loanOfficer": "Officier de prêt",
        "managementConsultant": "Conseiller en gestion",
        "manager": "Gestionnaire",
        "mutualFundSalesRepresentative": "Représentant des ventes de fonds communs",
        "portfolioManager": "Gestionnaire de portefeuille",
        "productManager": "Gestionnaire de produit",
        "securitiesTrader": "Marchand en valeurs mobilières",
        "statistician": "Statisticien",
        "stockBroker": "Courtier d'actions",
        "taxAssessmentAndCollectionsOfficer": "Officier de l'évaluation et de la perception des impôts",
        "treasurer": "Trésorier",
        "underwriter": "Souscripteur",
        "other": "Autre"
      }
    },
    "administrationAndHumanResources": {
      "title": "Administration et ressources humaines",
      "titles": {
        "administrativeAssistant": "Assistant(e) administratif(ve)",
        "clericalWorker": "Employé(e) de bureau",
        "consultant": "Conseiller(ère)",
        "customerServiceRepresentative": "Représentant(e) du service à la clientèle",
        "custodian": "Dépositaire(trice)",
        "executiveAssistant": "Assistant(e) exécutif(ve)",
        "executiveSeniorManagementAdministrationAndHumanResources": "Gestionnaire exécutif(ve)/principal(e), administration et ressources humaines",
        "facilitiesSpecialist": "Spécialiste des installations",
        "generalOfficeClerk": "Commis de bureau général",
        "humanResourcesConsultant": "Consultant(e) en ressources humaines",
        "humanResourcesSpecialist": "Spécialiste en ressources humaines",
        "inventoryControlClerk": "Commis au contrôle d'inventaire",
        "inventoryControlSpecialist": "Spécialiste du contrôle de l'inventaire",
        "manager": "Gestionnaire",
        "mediator": "Médiateur(trice)",
        "officeManager": "Gestionnaire de bureau",
        "personalAssistant": "Assistant(e) personnel(le)",
        "procurementOfficer": "Commis aux achats",
        "projectManager": "Gestionnaire de projet",
        "purchasingAgent": "Agent(e) d'achat",
        "payrollBenefitsAdministrator": "Administrateur(trice) de la paie/avantages sociaux",
        "receptionist": "Réceptionniste",
        "recruiter": "Recruteur",
        "recordsManagementTechnician": "Technicien en gestion des dossiers",
        "telephoneOperator": "Opérateur(trice) de téléphone",
        "unionRepresentative": "Représentant(e) syndical",
        "other": "Autre"
      }
    },
    "agricultureAndNaturalResources": {
      "title": "Agriculture et ressources naturelles",
      "titles": {
        "agriculturalWorker": "Travailleur agricole",
        "agricultureAndNaturalResourcesSupportActivities": "Activités de soutien à l'agriculture et aux ressources naturelles",
        "aquacultureWorker": "Travailleur de l'aquaculture",
        "breeder": "Éleveur",
        "conservationist": "Conservationniste",
        "customerServiceRepresentative": "Représentant(e) du service à la clientèle",
        "dairyWorker": "Travailleur laitier",
        "drillingOilAndGas": "Forage - Pétrole et gaz",
        "executiveSeniorManagementAgricultureAndNaturalResources": "Gestionnaire exécutif(ve)/principal(e), administration et ressources humaines(",
        "farmer": "Fermier(ère)",
        "fisheriesWorker": "Travailleur de la pêche",
        "florist": "Fleuriste",
        "foodProducer": "Producteur(trice) alimentaire",
        "forestryWorker": "Travailleur forestier",
        "grainElevatorOperator": "Opérateur d'élévateur de grains",
        "harvester": "Moissonneuse",
        "horticultureWorker": "Travailleur de l'horticulture",
        "inspector": "Inspecteur(trice)",
        "livestockWorker": "Travailleur du bétail",
        "loggingWorker": "Travailleur forestier",
        "managerAgricultureAndNaturalResources": "Gestionnaire, Agriculture et Ressources Naturelles",
        "metalsProcessingWorker": "Travailleur du traitement des métaux",
        "meteorologist": "Météorologue",
        "mineWorker": "Travailleur de mine",
        "nurseryGreenhouseWorker": "Travailleur en pépinière ou en serre",
        "oilIndustryWorker": "Travailleur de l'industrie pétrolière",
        "pulpAndPaperProcessingWorker": "Travailleur de la pâte et du papier",
        "quarryWorker": "Travailleur de carrière",
        "solarPowerWorker": "Travailleur de l'énergie solaire",
        "trapper": "Trappeur",
        "undergroundWorker": "Travailleur souterrain",
        "other": "Autre"
      }
    },
    "artsEntertainmentAndCommunications": {
      "title": "Arts, divertissement et communications",
      "titles": {
        "actorActress": "Acteur/Actrice",
        "advertisingSpecialist": "Spécialiste de la publicité",
        "animator": "Animateur(trice)",
        "announcerBroadcaster": "Annonceur/Diffuseur",
        "antiqueDealer": "Concessionnaire d'antique",
        "artisanCrafter": "Artisan(e)",
        "artist": "Artiste",
        "audioVisualTechnician": "Technicien audio-visuel",
        "author": "Auteur(e)",
        "casinoCustomerService": "Service à la clientèle du casino",
        "casinoDealer": "Marchand(e) de casino",
        "casinoGamingManager": "Gestionnaire de jeux de casino",
        "choreographer": "Chorégraphe",
        "communicationsSpecialist": "Spécialiste de la communication",
        "composer": "Compositeur(trice)",
        "conductor": "Conducteur(trice)",
        "curator": "Curateur(trice)",
        "dancer": "Danseur(euse)",
        "designer": "Concepteur(trice)",
        "director": "Réalisateur(trice)",
        "editor": "Éditeur(trice)",
        "executiveSeniorManagementArtsEntertainmentAndCommunications": "Gestionnaire, Arts, Divertissement et Communications",
        "filmVideoCameraOperator": "Opérateur(trice) de caméra/vidéo",
        "graphicArtist": "Artiste graphique",
        "graphicDesigner": "Concepteur(trice) graphique",
        "illustrator": "Illustrateur(trice)",
        "industrialDesigner": "Concepteur(trice) industriel",
        "instructor": "Instructeur(trice)",
        "interiorDesignerDecorator": "Concepteur(trice)/décorateur(trice) d'intérieur",
        "interpreter": "Interprète",
        "journalist": "Journaliste",
        "makeupArtist": "Artiste du maquillage",
        "managerArtsEntertainmentAndCommunications": "Gestionnaire, Arts, Divertissement et Communications",
        "mediaRelations": "Relations médiatiques",
        "model": "Modèle",
        "museumWorker": "Travailleur du musée",
        "musician": "Musicien(ne)",
        "performingArtist": "Artiste en scène",
        "photographer": "Photographe",
        "printer": "Imprimant(e)",
        "producer": "Producteur(trice)",
        "productionWorker": "Travailleur de production",
        "proofreader": "Correcteur(trice) d’épreuves",
        "publicRelationsWorker": "Travailleur des relations publiques",
        "publicist": "Journaliste",
        "publisher": "Éditeur",
        "reporter": "Journaliste",
        "researcher": "Chercheur(euse)",
        "sculptor": "Sculpteur(trice)",
        "singer": "Chanteur(euse)",
        "switchboardOperator": "Opérateur(trice) de tableau",
        "tattooArtist": "Artiste de tatouage",
        "theatreWorker": "Travailleur de théâtre",
        "translator": "Traducteur(trice)",
        "writer": "Auteur(e)",
        "other": "Autre"
      }
    },
    "educationAndTraining": {
      "title": "Éducation et formation",
      "titles": {
        "caretakerJanitor": "Soignant(e)/Concierge",
        "childCareWorker": "Éducateur(trice) en enfance",
        "counsellor": "Conseiller(ère)",
        "dean": "Doyen(ne)",
        "earlyChildhoodEducator": "Éducateur de la petite enfance",
        "educationAndTrainingSupportActivities": "Activités de soutien à l'éducation et à la formation",
        "educationalAssistant": "Assistant(e) pédagogique",
        "employmentCounsellor": "Conseiller(ère) en emploi",
        "executiveSeniorManagement": "Cadres supérieurs",
        "historian": "Historien(ne)",
        "instructor": "Instructeur(trice)",
        "librarian": "Bibliothécaire",
        "lifeCoach": "Entraîneur de vie",
        "managerEducationAndTraining": "Gestionnaire, Éducation et Formation",
        "officeAdminSecretary": "Administrateur(e)/secrétaire de bureau",
        "professor": "Professeur(e)",
        "researchAssistant": "Assistant(e) de recherche",
        "researcher": "Chercheur(euse)",
        "schoolBusDriver": "Conducteur(trice) d'autobus scolaire",
        "schoolCounsellor": "Conseiller(ère) scolaire",
        "schoolPrincipal": "Directeur(trice) d'école",
        "schoolCollegeAdministrator": "Administrateur(trice) d'école/collège",
        "superintendent": "Surintendant(e)",
        "teacher": "Enseignant(e)",
        "teachingAssistant": "Assistant(e) pédagogique",
        "trainer": "Formateur(trice)",
        "tutor": "Tuteur(trice)",
        "vicePrincipal": "Vice-directeur(trice)",
        "other": "Autre"
      }
    },
    "engineeringArchitectureAndScience": {
      "title": "Ingénierie, Architecture et Sciences",
      "titles": {
        "aerospaceEngineer": "Ingénieur(e) aéronautique",
        "architect": "Architect(e)",
        "astronomer": "Astronome",
        "biochemist": "Biochimiste",
        "bioEngineer": "Bioingénieur(e)",
        "biologist": "Biologiste",
        "cADDraftingTechnician": "Technicien(ne) de CAD/Rédaction",
        "chemicalEngineer": "Ingénieur(e) chimique",
        "chemist": "Chimiste",
        "civilEngineer": "Ingénieur(e) civil",
        "consultant": "Conseiller(ère)",
        "electricalEngineer": "Ingénieur(e) électrique",
        "electricalPowerAndCableWorker": "Monteur(euse) de lignes électriques et de câbles",
        "energyNuclearEngineer": "Ingénieur(e) d'énergie nucléaire",
        "executiveSeniorManagementEngineeringArchitectureAndScience": "Gestionnaire, Ingénierie, Architecture et Science",
        "geochemist": "Géochimiste",
        "geologist": "Géologue",
        "industrialEngineer": "Ingénieur(e) industriel",
        "inspector": "Inspecteur(trice)",
        "laboratoryTechnician": "Technicien(ne) de laboratoire",
        "managerEngineeringArchitectureAndScience": "Gestionnaire, Ingénierie, Architecture et Science",
        "manufacturingEngineer": "Ingénieur(e) de fabrication",
        "marineEngineer": "Ingénieur(e) marin",
        "mathematician": "Mathématicien(ne)",
        "mechanicalEngineer": "Ingénieur(e) mécanique",
        "metallurgist": "Métallurgiste",
        "meteorologist": "Météorologue",
        "miningEngineer": "Ingénieur(e) minier",
        "nuclearPowerWorker": "Travailleur en énergie nucléaire",
        "petroleumEngineer": "Ingénieur(e) de pétrole",
        "physicist": "Physicien(ne)",
        "powerSystemsEngineer": "Ingénieur(e) de systèmes énergetique",
        "professionalEngineer": "Ingénieur(e) professionnel",
        "projectManager": "Gestionnaire de projet",
        "researcher": "Chercheur(euse)",
        "scientist": "Scientifique",
        "sociologistAnthropologist": "Sociologue/anthropologue",
        "urbanPlanner": "Planificateur(trice) urbain",
        "other": "Autre"
      }
    },
    "governmentDiplomaticAndProtectiveServices": {
      "title": "Gouvernement, services diplomatiques et de protection",
      "titles": {
        "ambassadorAttacheOrCounsellorOfAnAmbassador": "Ambassadeur(drice), Attache ou Conseiller(ère) d'un Ambassadeur(drice)",
        "borderSecurityAgent": "Agent(e) de sécurité des frontières",
        "cityAdministrator": "Administrateur(trice) de ville",
        "cityCounsellor": "Conseiller(ère) de ville",
        "civilServant": "Fonctionnaire",
        "communityServicesWorker": "Travailleur de services communautaires",
        "consultant": "Conseiller(ère)",
        "correctionsOfficer": "Agent(e) de correction",
        "customsOfficer": "Agent(e) de douanes",
        "deputyMinister": "Sous-ministre",
        "diplomaticPersonnel": "Personnel diplomatique",
        "emergencyMedicalTechnician": "Technicien(ne) médical d'urgence",
        "firefighter": "Pompier(ère)",
        "governmentAdministrator": "Administrateur(trice) au gouvernement",
        "governmentInspector": "Inspecteur(trice) de gouvernement",
        "governmentServicesOfficer": "Agent(e) des services gouvernementaux",
        "governmentDiplomaticAndProtectiveServicesSupportActivities": "Gouvernement, services de soutien diplomatiques et de protection",
        "headOfGovernmentAgencyInstituteOrCharity": "Responsable de l'Agence Gouvernemental, Institut ou Charité",
        "indigenousCouncilMember": "Membre du conseil Autochtones",
        "intelligenceAnalysisSpecialist": "Spécialiste/analyste en intelligence",
        "mayor": "Maire",
        "memberOfGovernment": "Membre du gouvernement",
        "paramedic": "Paramédical",
        "policeOfficer": "Policier(ère)",
        "policyAnalyst": "Analyste politique",
        "postalWorker": "Facteur(trice)",
        "programOfficer": "Agent(e) de programme",
        "regulatoryOfficer": "Agent(e) régulateur(trice)",
        "schoolBoardTrustee": "Responsable du conseil scolaire",
        "securityGuard": "Garde de sécurité",
        "socialWorker": "Travailleur social",
        "urbanPlanner": "Planificateur(trice) urbain",
        "wasteRemoval": "Ramassage des déchets",
        "other": "Autre"
      }
    },
    "hospitalityFoodAndTourism": {
      "title": "Hospitalité, Alimentation et Tourisme",
      "titles": {
        "baker": "Boulanger(re)",
        "bartender": "Barman(aid)",
        "butcher": "Boucher(ère)",
        "caterer": "Traiteur",
        "chef": "Chef",
        "cook": "Cuisinier(ère)",
        "customerServiceRepresentative": "Représentant(e) du service à la clientèle",
        "eventsPlanner": "Planificateur(trice) d'événements",
        "executiveSeniorManagementHospitalityFoodAndTourism": "Cadre/haute gestion, hôtellerie, alimentation et tourisme",
        "ferryWorker": "Travailleur de traversier",
        "foodServicesWorker": "Travailleur des services alimentaires",
        "hospitalityServicesWorker": "Employé(e) des services d'hospitalité",
        "hostHostess": "Hôte/Hôtesse",
        "hotelStaff": "Personnel(le) en hôtellerie",
        "housekeeper": "Travailleur à l'entretien de la maison",
        "kitchenStaff": "Personnel(le) de cuisine",
        "manager": "Gestionnaire",
        "pastryChef": "Chef pâtissier(ere)",
        "restaurantManager": "Gestionnaire de restaurant",
        "sousChef": "Sous-chef",
        "tourTravelGuide": "Guide de voyage",
        "travelAgent": "Agent(e) de voyage",
        "waiterServer": "Serveur(euse)",
        "other": "Autre"
      }
    },
    "informationTechnology": {
      "title": "Informatique (Ti)",
      "titles": {
        "computerConsultant": "Conseiller(ère) informatique",
        "computerEngineer": "Ingénieur(e) informatique",
        "dataCentreManager": "Gestionnaire de centre de données",
        "dataEntryClerk": "Commis à l'entrée de données",
        "electronics": "Électroniques",
        "executiveSeniorManagementInformationTechnology": "Responsabilité/haute gestion, technologie de l'information",
        "informationSystems": "Systèmes d'information",
        "projectManager": "Gestionnaire de projet",
        "specialist": "Spécialiste",
        "multimediaProgrammer": "Programmeur(e) multimédia",
        "productSpecialist": "Spécialiste du produit",
        "softwareEngineer": "Ingénieur(e) de logiciel",
        "switchboardOperator": "Opérateur(trice) de tableau",
        "technicalSupportAgent": "Agent(e) de soutien technique",
        "telecommunicationsInstaller": "Installateur(trice) de télécommunications",
        "telecommunicationsSpecialist": "Spécialiste des télécommunications",
        "webDesigner": "Concepteur(trice) Web",
        "productManager": "Gestionnaire de produit",
        "techExecutive": "Exécutif(ve) Technique",
        "uIUXDesigner": "Concepteur(trice) UI/UX",
        "other": "Autre"
      }
    },
    "legalServices": {
      "title": "Services légaux",
      "titles": {
        "administrativeAssistant": "Assistant(e) administratif(ve)",
        "arbitrator": "Mediateur",
        "articlingStudent": "Stagiaire",
        "bailiff": "Huissier",
        "byLawOfficer": "Agent(e) des règlements",
        "courtOfficer": "Officier(ère) du tribunal",
        "courtReporter": "Sténographe",
        "judge": "Juge",
        "lawClerk": "Légiste",
        "lawyer": "Avocat(e)",
        "legalSupportActivities": "Activités de soutien juridique",
        "magistrateMaster": "Magistrat(e)/Maître",
        "notary": "Notaire",
        "paralegal": "Parajuriste",
        "paroleOfficer": "Agent(e) de libération conditionnelle",
        "probationOfficer": "Agent(e) de probation",
        "registrar": "Registraire",
        "other": "Autre"
      }
    },
    "medicalHealthAndCareGiving": {
      "title": "Santé et soins médicaux",
      "titles": {
        "acupuncturist": "Acupuncteur(trice)",
        "audiologist": "Audiologiste",
        "cardiologist": "Cardiologue",
        "chiropractor": "Chiropraticien",
        "counsellor": "Conseiller(ère)",
        "coroner": "Coroner",
        "dayCareWorker": "Éducateur(trice) en enfance",
        "dentalHygienist": "Hygieniste dentaire",
        "dentist": "Dentiste",
        "dietitian": "Dieteticien(ne)",
        "dispatcher": "Opérateur(trice)",
        "doctor": "Docteur",
        "fosterParent": "Parent d’accueil",
        "funeralHomeWorker": "Travailleur(euse) de salon funéraire",
        "healthCareCounsellor": "Conseiller(ère) en soins médicaux",
        "homeCareWorker": "Travailleur(euse) de soins à domicile",
        "homeopath": "Homéopathe",
        "hospitalAdministrator": "Administrateur(trice) de l'hôpital",
        "inspector": "Inspecteur(trice)",
        "laboratoryTechnician": "Technicien(ne) de laboratoire",
        "massageTherapist": "Massothérapeute",
        "medicalTechnician": "Technicien(ne) médical",
        "midwife": "Sage-femme",
        "medicalImagingSpecialist": "Spécialiste de l'imagerie médicale",
        "mortician": "Croque-mort(e)",
        "nanny": "Nounou",
        "naturopath": "Naturopathe",
        "nurse": "Infirmière",
        "nutritionist": "Nutritionniste",
        "occupationalTherapist": "Ergothérapeute",
        "ophthalmologist": "Ophtalmologiste",
        "optician": "Opticien(ne)",
        "optometrist": "Optométriste",
        "paramedic": "Paramédical",
        "pharmacyTechnician": "Technicien(ne) en pharmacie",
        "pathologist": "Pathologiste",
        "personalSupportWorker": "Travailleur de soutien personnel",
        "pharmacist": "Pharmacien(ne)",
        "physiotherapist": "Physiothérapeute",
        "podiatrist": "Podiatre",
        "psychologist": "Psychologue",
        "Radiologist": "Radiologiste",
        "rehabilitationSpecialist": "Spécialiste de la réhabilitation",
        "respiratoryTherapist": "Thérapiste respiratoire",
        "socialServicesWorker": "Travailleur de services sociaux",
        "speechPathologist": "Pathologiste de la parole",
        "surgeon": "Chirurgien",
        "therapist": "Thérapeute",
        "veterinarian": "Vétérinaire",
        "veterinarianTechnician": "Technicien(ne) vétérinaire",
        "other": "Autre"
      }
    },
    "militaryServices": {
      "title": "Services militaires",
      "titles": {
        "administrativeOfficer": "Agent(e) administratif(ve)",
        "airTrafficController": "Contrôleur(euse) du trafic aérien",
        "aircraftTechnician": "Technicien(ne) d'aéronefs",
        "artillerySpecialist": "Spécialiste de l'artillerie",
        "chaplain": "Aumônier(ère)",
        "combatMedicCorpsman": "Médecin de combat/Infirmier(ère) militaire",
        "combatSoldierInfantry": "Soldat(e) de combat/Infanterie",
        "constructionCombatEngineer": "Ingénieur(e) de construction/combat",
        "cookFoodServices": "Cuisinier(ère)/Services alimentaires",
        "cyberWarfareSpecialist": "Spécialiste de la cyberguerre",
        "dentalTechnician": "Technicien(ne) dentaire",
        "electrician": "Électricien(ne)",
        "executiveSeniorManagement": "Cadre/Haute direction",
        "explosiveOrdnanceDisposalEod": "Neutralisation des explosifs et munitions (NEM)",
        "financeSpecialist": "Spécialiste des finances",
        "firefighter": "Pompier(ère)",
        "intelligenceAnalyst": "Analyste du renseignement",
        "judgeAdvocateJag": "Juge-avocat (JAG)",
        "logisticsAndSupplyOfficer": "Officier(ère) de la logistique et de l'approvisionnement",
        "mechanic": "Mécanicien(ne)",
        "mentalHealthSpecialist": "Spécialiste de la santé mentale",
        "militaryPilot": "Pilote militaire",
        "militaryPoliceOfficer": "Officier(ère) de la police militaire",
        "navalOfficer": "Officier(ère) de marine",
        "nurse": "Infirmier(ère)",
        "personnelSpecialist": "Spécialiste du personnel",
        "publicAffairsSpecialist": "Spécialiste des affaires publiques",
        "quartermaster": "Quartier-maître",
        "recruiter": "Recruteur(euse)",
        "securityForceProtection": "Sécurité/Protection des forces",
        "signalsCommunicationsSpecialist": "Spécialiste des signaux/communications",
        "specialOperations": "Opérations spéciales",
        "submariner": "Sous-marinier(ère)",
        "supportActivities": "Activités de soutien",
        "surgeon": "Chirurgien(ne)",
        "trainingInstructor": "Instructeur(trice) de formation",
        "truckDriver": "Conducteur(trice) de camion",
        "welder": "Soudeur(euse)",
        "other": "Autre"
      }
    },
    "realEstateAndRelated": {
      "title": "Immobilier et services connexes",
      "titles": {
        "appraiser": "Évaluateur(trice)",
        "homeBuilder": "Constructeur de maison",
        "homeInspector": "Inspecteur(trice) de maison",
        "landDeveloper": "Développeur(se) de terrain",
        "landSurveyor": "Arpenteur(euse)",
        "mortgageBroker": "Courtier en hypothèques",
        "propertyManager": "Gestionnaire de propriété",
        "propertyAssessor": "Évaluateur(trice) de propriété",
        "realEstateAgent": "Agent(e) immobilier",
        "renovator": "Rénovateur(trice)",
        "realEstateBroker": "Courtier immobilier",
        "realEstateAssessor": "Évaluateur(trice) immobilier",
        "other": "Autre"
      }
    },
    "religiousVocation": {
      "title": "Vocation religieuse",
      "titles": {
        "chaplain": "Aumônier(ère)",
        "clergyman": "Ecclésiastique",
        "deacon": "Diacre",
        "imam": "Imam",
        "minister": "Ministre",
        "missionary": "Missionnaire",
        "monk": "Moine",
        "monsignor": "Monsignor",
        "nun": "Nonne",
        "priest": "Prêtre",
        "rabbi": "Rabbin",
        "religiousWorker": "Travailleur religieux",
        "other": "Autre"
      }
    },
    "salesRepairAndRetailService": {
      "title": "Ventes, réparation et service de détail",
      "titles": {
        "animalCareWorker": "Travailleur de soin des animaux",
        "animalTrainer": "Entraîneur des animaux",
        "applianceRepairTechnician": "Technicien(ne) de réparation d'appareils",
        "auctioneer": "Commissaire-priseur",
        "automotiveRepair": "Réparation automobile",
        "automotiveSales": "Ventes d'automobiles",
        "barber": "Barbier",
        "buyer": "Acheteur(euse)",
        "callCentreRepresentative": "Représentant(e) du centre d'appel",
        "cashier": "Caissier(ère)",
        "cleaningServiceProvider": "Fournisseur de services de nettoyage",
        "cosmetologist": "Cosmétologue",
        "customerServiceRepresentative": "Représentant(e) du service à la clientèle",
        "dryCleaner": "Nettoyeurs à sec",
        "electrologist": "Électrolyste",
        "esthetician": "Esthéticien(ne)",
        "executiveSeniorManagementSalesRepairAndRetailService": "Responsabilité/haute direction, ventes, réparations et services de détail",
        "exterminatorPestControl": "Contrôle de l'extermination/des parasites",
        "franchiseBusinessOwner": "Franchise - Propriétaire de l'entreprise",
        "hairdresser": "Coiffeur(euse)",
        "importerExporter": "Importateur/exportateur",
        "installer": "Installateur(trice)",
        "jeweler": "Bijoutier(ère)",
        "managerSalesRepairAndRetailService": "Gestionnaire des ventes, réparation et service de détail",
        "marketingRepresentative": "Représentant(e) de marketing",
        "merchandiser": "Marchandiseur(euse)",
        "retailWorker": "Travailleur(euse) du détail",
        "salesAndRetailSupportWorker": "Travailleur(euse) de soutien aux ventes et au détail",
        "salesperson": "Vendeur(euse)",
        "seamstressTailor": "Couturière/tailleur",
        "serviceStationAttendant": "Responsable de la station de service",
        "shoeRepairMaker": "Réparation/Fabricant de chaussures",
        "smallEngineTechnician": "Technicien(ne) de petit moteur",
        "spaServiceProvider": "Fournisseur(trice) de services de centre de bien-être",
        "storeManager": "Gestionnaire de magasin",
        "telemarketer": "Télévendeur(euse)",
        "televisionTechnician": "Technicien(ne) de télévision",
        "upholsterer": "Tapissier(ere)",
        "visualDisplayMerchandisingSpecialist": "Spécialiste en affichage visuel/commercialisation",
        "windowWasher": "Laveur(euse) de fenêtre",
        "other": "Autre"
      }
    },
    "sportsAndLeisure": {
      "title": "Sports et loisirs",
      "titles": {
        "amusementParkWorker": "Travailleur de parc d'attractions",
        "coach": "Entraîneur(trice)",
        "lifeguard": "Sauveteur(trice)",
        "personalServicesWorker": "Travailleur(euse) de services personnels",
        "personalTrainer": "Entraîneur(e) personnel(le)",
        "professionalAthlete": "Athlète professionnel",
        "recreationalGuide": "Guide récréatif",
        "sportsAgent": "Agent(e) de sport",
        "sportsInstructor": "Instructeur(e) de sport",
        "sportsManager": "Gestionnaire de sport",
        "sportsOfficial": "Responsable sportif",
        "sportsTherapist": "Thérapeute sportif",
        "other": "Autre"
      }
    },
    "tradesConstructionAndManufacturing": {
      "title": "Métiers, construction et fabrication",
      "titles": {
        "apprentice": "Stagiaire en construction",
        "assemblyWorker": "Travailleur(euse) d'assemblage",
        "blacksmith": "Forgeron",
        "boilermaker": "Chaudronnier(ère)",
        "bricklayer": "Maçon",
        "builder": "Constructeur(trice)",
        "cabinetMaker": "Fabricant(e) d'armoires",
        "carpenter": "Menuisier(ere)",
        "concreteWorker": "Travailleur(euse) du béton",
        "constructionWorker": "Travailleur(euse) de construction",
        "craneOperator": "Opérateur de grue",
        "cutter": "Coupeur(euse)",
        "developer": "Développeur(euse)",
        "draftingDesign": "Rédaction/conception",
        "driller": "Foreur(euse)",
        "drywaller": "Poseur de cloisons sèches",
        "electrician": "Électricien(ne)",
        "elevator Technician": "Technicien(ne) d'ascenseur",
        "engineer": "Ingénieur(e)",
        "executiveSeniorManagementTradesConstructionAndManufacturing": "Responsable de la direction, du commerce, de la construction et de la fabrication",
        "fabricator": "Assembleur(euse)",
        "factoryWorker": "Travailleur(euse) d'usine",
        "finisher": "Perfectionniste de la construction",
        "forkliftOperator": "Opérateur(e) de chariot élévateur",
        "foundryWorker": "Ouvrier de fonderie",
        "framer": "Encadreur(euse)",
        "gasFitter": "Installateur de gaz",
        "generalContractor": "Entrepreneur général",
        "glassFormerFinisher": "Travailleur de la vitre",
        "heavyDutyMechanic": "Mécanicien(ne) de service lourd",
        "heavyEquipmentOperator": "Opérateur(e) d'équipement lourd",
        "hVACInstaller": "Installateur HVAC",
        "inspector": "Inspecteur(trice)",
        "installer": "Installateur(trice)",
        "ironworker": "Travailleur(euse) du fer",
        "labourer": "Ouvrier(ère)",
        "landscaper": "Ouvrier(ère) en travaux paysagers",
        "locksmith": "Serrurier(ere)",
        "machineFitter": "Installeur(euse) de machine",
        "machineOperator": "Opérateur(euse) de machine",
        "manager": "Gestionnaire(s)",
        "manufacturingWorker": "Travailleur(euse) en fabrication",
        "mechanic": "Mécanicien(ne)",
        "metalWorker": "Travailleur(euse) en métal",
        "millwright": "Mécanicien de chantier",
        "oilPipelineWorker": "Travailleur(euse) du pétrole et pipeline",
        "painter": "Peintre",
        "paver": "Travailleur(euse) de la pose de pavé",
        "pipefitter": "Tuyauteur(euse)",
        "plasterer": "Plâtrier(ère)",
        "plumber": "Plombier(ère)",
        "purchasingManager": "Gestionnaire d'achat",
        "qualityAssuranceAnalyst": "Analyste de l'assurance qualité",
        "recycler": "Travailleur(euse) en recyclage",
        "renovator": "Rénovateur(trice)",
        "roofer": "Couvreur(euse)",
        "sheetMetalWorker": "Travailleur(euse) du métal",
        "skilledLabourer": "Ouvrier(ère) qualifié",
        "steamfitter": "Monteur(euse) de système vapeur",
        "surveyor": "Arpenteur(euse)",
        "textileWorker": "Travailleur(euse) du textile",
        "tileSetter": "Carreleur(euse)",
        "toolAndDieMaker": "Fabricant(e) d'outils et de matrices",
        "tradesperson": "Personne de métier",
        "welder": "Soudeur(euse)",
        "weaver": "Tisseur(euse)",
        "woodworker": "Travailleur(euse) du bois",
        "other": "Autre"
      }
    },
    "transportationAndUtilities": {
      "title": "Transports et services",
      "titles": {
        "airTrafficController": "Contrôleur(euse) du trafic aérien",
        "aircraftTechnician": "Technicien(ne) d'aéronefs",
        "airlineAgent": "Agent(e) de ligne aérienne",
        "baggageHandler": "Agent(e) de bagages",
        "busDriver": "Conducteur(trice) d'autobus",
        "cargoWorker": "Employé du fret",
        "conductor": "Conducteur(trice)",
        "courierDelivery": "Courrier/Livraison",
        "customsInspection": "Inspections douanières",
        "deliveryDriver": "Chauffeur-livreur",
        "dockWorker": "Travailleur du dock",
        "drillerBlaster": "Perceur(euse) et travailleur(euse) en explosif",
        "executiveSeniorManagementTransportationAndUtilities": "Responsabilité/Responsable de la direction, du transport et des services",
        "ferryWorker": "Travailleur de traversier",
        "flightAttendant": "Agent(e) de bord",
        "flightInstructor": "Instructeur(trice) de vol",
        "heatingServiceProvider": "Fournisseur de service de chauffage",
        "inspector": "Inspecteur(trice)",
        "janitor": "Concierge",
        "limoDriverChauffeur": "Conducteur(trice) de limousine",
        "logisticsAnalyst": "Analyste logistique",
        "mover": "Déménageur(euse)",
        "oilHeating": "Chauffage à huile",
        "pilot": "Pilote",
        "publicWorksMaintenance": "Travaux publics",
        "railwayMarineTransportWorker": "Travailleur(euse) du transport ferroviaire/maritime",
        "shipmentBroker": "Courtier(ère) en expédition",
        "shipperReceiver": "Expéditeur/récepteur",
        "taxiDriver": "Chauffeur de taxi",
        "transportationAndUtilitiesSupportActivities": "Le transport et les services publics supportant les activités",
        "truckDriver": "Conducteur(trice) de camion",
        "utilityWorker": "Travailleur(euse) aux travaux publics",
        "wellDrillersOperators": "Perceurs/Opérateurs de puits",
        "wellSiteSupervisor": "Superviseur du site",
        "waterTreatmentTechnician": "Technicien(ne) en traitement de l'eau",
        "other": "Autre"
      }
    }
  },
  "areasOfStudy": {
    "aeronauticsAndAviationScience": "L'aéronautique et la science de l'aviation",
    "anthropology": "Anthropologie",
    "art": "Art",
    "businessAdministration": "Administration d'entreprise",
    "chemistry": "Chimie",
    "economics": "Économie",
    "education": "Éducation",
    "engineering": "Ingénierie",
    "environmentalScienceAndHealth": "Science et santé de l'environnement",
    "journalismAndMassCommunication": "Journalisme et communication de masse",
    "music": "Musique",
    "nursing": "Soins infirmiers",
    "oceanography": "Océanographie",
    "pharmacy": "Pharmacie",
    "photography": "Photographie",
    "physicalTherapy": "Thérapie physique",
    "politicalScienceAndInternationalRelations": "Science politique et relations internationales",
    "psychology": "Psychologie",
    "publicRelationsAndAdministration": "Relations publiques et administration",
    "statistics": "Statistiques",
    "urbanPlanning": "Urbanisme"
  },
  "previousCompanyType": "{{companyType}} précédent",
  "previousJobTitle": "{{jobTitle}} précédent(e)",
  "previousEmployerName": "{{employerName}} précédent"
}
